module.exports = __webpack_public_path__ + "static/media/Plamídio.786f3cbd.glb";